import React, { useEffect } from 'react';
import { Sparkles } from './MaxCharacter';

export default function SceneCelebration({ onDone }) {
  useEffect(() => {
    const id = setTimeout(onDone, 2000);
    return () => clearTimeout(id);
  }, [onDone]);

  return (
    <div style={overlayStyle}>
      <div style={{ position: 'relative', display: 'inline-block' }}>
        <img src="/assets/max.png" alt="Max" style={{ width: 200, height: 200, objectFit: 'contain' }} className="anim-happy-pop" />
        <Sparkles />
      </div>
      <div style={badgeStyle}>
        <span style={badgeTextStyle}>Great job! 🎉</span>
      </div>
    </div>
  );
}

const overlayStyle = {
  position: 'absolute',
  inset: 0,
  background: 'rgba(255,255,255,0.85)',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 20,
  zIndex: 10,
  animation: 'fade-in-up 0.4s ease-out both',
};

const badgeStyle = {
  background: '#FFD600',
  border: '5px solid #111',
  borderRadius: 24,
  padding: '12px 36px',
  boxShadow: '5px 5px 0 #111',
};

const badgeTextStyle = {
  fontFamily: "'Fredoka One', cursive",
  fontSize: 'clamp(1.4rem, 4vw, 2.2rem)',
  color: '#111',
};
